import React, { useEffect, useState } from 'react';
import { trackAddToCart } from '../utils/metaPixel';
export function MobileStickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling down a bit (e.g., past the hero section)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 p-4 z-50 md:hidden shadow-[0_-10px_20px_rgba(0,0,0,0.1)] transition-transform duration-300 ease-in-out ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-250">
      <div className="flex items-center justify-between gap-4" data-id="element-251">
        <div className="flex flex-col" data-id="element-252">
          <span className="text-xs text-gray-500 line-through" data-id="element-253">205€</span>
          <span className="text-xl font-bold text-brand-dark leading-none" data-id="element-254">
            26€
          </span>
        </div>
        <a href="https://pay.hotmart.com/W104988940M?off=y9azogt4&checkoutMode=10&bid=1774913274137" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="flex-1 bg-brand-gold text-brand-dark font-bold text-center py-3 px-4 rounded-full text-sm shadow-md active:scale-95 transition-transform min-h-[48px] flex items-center justify-center" data-id="element-255">
          SÍ, QUIERO MI REINICIO
        </a>
      </div>
    </div>;
}